import { ftbPatterns } from '../marketPatterns';
import { getMarketCachedValue, setMarketCachedValue } from '../utils';
import { MarketTranslationStrategy } from './types';
import { getCurrentLanguage, shouldLocalize } from './utils';

export const translateFTBMarket: MarketTranslationStrategy = (marketName, marketType, t) => {
  if (!shouldLocalize()) {
    return marketName;
  }

  const directTranslationKey = marketName.toLowerCase();

  const language = getCurrentLanguage();
  const cachedTranslation = getMarketCachedValue(language, directTranslationKey);
  if (cachedTranslation) {
    return cachedTranslation;
  }

  const directTranslation = t(directTranslationKey, {
    ns: 'ftb_markets',
    defaultValue: null,
  });

  if (directTranslation) {
    const language = getCurrentLanguage();
    setMarketCachedValue(language, directTranslationKey, directTranslation);
    return directTranslation;
  }

  const rule = ftbPatterns.find(({ pattern }: { pattern: RegExp }) => pattern.test(marketName));

  if (rule && rule.params) {
    const match = rule.pattern.exec(marketName);

    if (match) {
      const additionalParams = rule.params.reduce((acc: { [key: string]: string }, param, index) => {
        if (match[index + 1]) {
          acc[param] = match[index + 1];
        }
        return acc;
      }, {});

      const translation = t(rule.key, marketName, {
        ns: 'ftb_markets',
        ...additionalParams,
        interpolation: { escapeValue: false },
      });

      const language = getCurrentLanguage();
      setMarketCachedValue(language, marketName, translation);

      return translation;
    }
  }

  return marketName;
};
